import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class CreateTownCommand implements IMessage {
    code!: string;
    name!: string;
    departmentId!: Guid;

    public constructor(init?: Partial<CreateTownCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "POST";

    getUrl = () => `/admin/towns`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            code: this.code,
            name: this.name,
            departmentId: this.departmentId,
        };
    }
}